$('#myModal').ready(function() {
  var modal = document.getElementById('myModal');
  var closeBtn = document.getElementById("closePopup");
    var close = document.getElementById("continue-browsing");
  close.onclick = function() {
	modal.style.display = "none";
  	$.cookie("LOC", "auth", {
        expires : 30,
        path: '/',
      });
}
closeBtn.onclick = function() {
	modal.style.display = "none";
  	$.cookie("LOC", "auth", {
        expires : 30,
        path: '/',
      });
}

  checkLoc();
})

function checkLoc(){
    $.getJSON("https://api.geoapify.com/v1/ipinfo?&apiKey=ccb6b78421be4e91bbb19d0a18a223cc", function(response){

    if(response.country.iso_code == 'CA') {
      var modal = document.getElementById('myModal');
      var LOC = $.cookie('LOC');
          
      if (LOC == 'auth') {
        modal.style.display = "none";
      } else {
        modal.style.display = "block";
        $.cookie("LOC", "unauth", {
          expires : 30,
          path: '/',
        
        });
      }  
                

    }

  });
}


